"use strict";

import $ from "jquery";
import noUiSlider from "noUiSlider";
import wNumb from "wNumb";

class RangeSlider
{
    constructor(slider, min, max, options) {
        this.options = Object.assign({}, {
            onChange: null
        }, options);

        // Required.
        if ((this.slider = $(slider)).length < 1 ||
            (this.min = $(min)).length < 1 ||
            (this.max = $(max)).length < 1) {
            return;
        }

        this.value_min = 0;
        this.value_max = 7000;

        this.setup(this.slider[0], [this.min[0], this.max[0]]);
    }

    setup(slider, inputs) {
        noUiSlider.create(slider, {
            connect: true,
            format: wNumb({
                decimals: 0
            }),
            start: [this.value_min, this.value_max],
            step: 5,
            range: {
                "min": this.value_min,
                "max": this.value_max
            }
        });

        this.setExisting(slider, inputs);

        // Global reference for resetting the slider.
        window.VSSlider = this;
    }

    setExisting(slider, inputs) {
        let min, max;

        if (this.min.val()) {
            min = parseInt(this.min.val(), 0);
        }

        if (this.max.val()) {
            max = parseInt(this.max.val(), 0);
        }

        slider.noUiSlider.set([min, max]);
        this.listen(slider, inputs);
        this.sliderInterface = slider;
    }

    listen(slider, inputs) {
        slider.noUiSlider.on("update", (values, handle) => {
            inputs[handle].value = values[handle];
        });

        slider.noUiSlider.on("set", (values, handle) => {
            inputs[handle].value = values[handle];

            if (typeof this.options.onChange === "function") {
                this.options.onChange("price_min", inputs[0].value);
                this.options.onChange("price_max", inputs[1].value);
            }
        });

        // min
        inputs[0].addEventListener("change", () => {
            slider.noUiSlider.set([inputs[0].value, null]);
        });
        $(inputs[0]).keypress((event) => {
            if (event.which == 13) {
                slider.noUiSlider.set([inputs[0].value, null]);
            }
        });

        // max
        inputs[1].addEventListener("change", () => {
            slider.noUiSlider.set([null, inputs[1].value]);
        });
        $(inputs[1]).keypress((event) => {
            if (event.which == 13) {
                slider.noUiSlider.set([null, inputs[1].value]);
            }
        });
    }

    reset() {
        this.sliderInterface.noUiSlider.set([0, 7000]);
    }
}

export default RangeSlider;
